<agr-summary-card [actions]="actions" [title]="'virusMonitor.dashboardWidget.title' | translate">
  <div class="content">
    @if (store.hasVirusMonitorRegistrations()) {
      <app-disease-dashboard-widget-header
        (selectedDatesChanges)="onSelectedDatesChange($event)"
        [lastCalculatedOnOverride]="store.virusMonitorCalculationDate()"
        [maximalDateOverride]="store.virusMonitorMaxAdviceDate()"
        [minimalDateOverride]="store.virusMonitorMinAdviceDate()"
        [cropYear]="store.cropYear()"
        [translationPrefix]="translationPrefix"
      />
      <mat-divider />
      <div class="buttons-section">
        @if (showAdviceButton()) {
          <button (click)="onViewAdvice()" class="w-100" color="primary" data-test="view-advice-button" mat-flat-button>
            {{ 'virusMonitor.dashboardWidget.viewAdvice' | translate }}
          </button>
        }

        <button
          (click)="onAction('top')"
          [disabled]="isActionDisabled()"
          [matMenuTriggerFor]="actionMenuTop.menu"
          class="action-button"
          color="accent"
          mat-flat-button
        >
          <app-virus-monitor-action-menu #actionMenuTop [advices]="selectedCropFieldAdvices()" />
          <mat-icon>add</mat-icon>
          {{ actionButtonLabel() }}
        </button>

        <app-recalculate-button
          (recalculate)="onRecalculate()"
          [disabled]="isRecalculationDisabled()"
          [disabledTooltip]="isCropYearReadOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
          [isLoading]="store.isVirusMonitorCropFieldsSyncing()"
          [label]="'virusMonitor.shared.recalculateAdviceAll' | translate"
        />
      </div>

      <div class="flex--row spacing--margin-vertical">
        <app-disease-dashboard-widget-table
          (selectedCropFieldsChanged)="onCropFieldSelectionChange($event)"
          [advices]="store.virusMonitorAdvices()"
          [selectedDates]="selectedDates()"
          [translationPrefix]="translationPrefix"
          class="w-100"
        />
      </div>

      <button
        (click)="onAction('bottom')"
        [disabled]="isActionDisabled()"
        [matMenuTriggerFor]="actionMenuBottom.menu"
        class="action-button"
        color="accent"
        mat-flat-button
      >
        <app-virus-monitor-action-menu #actionMenuBottom [advices]="selectedCropFieldAdvices()" />
        <mat-icon>add</mat-icon>
        {{ actionButtonLabel() }}
      </button>

      @if (showAdviceButton()) {
        <button
          (click)="onViewAdvice()"
          class="view-advice-button"
          color="primary"
          data-test="view-advice-button"
          mat-flat-button
        >
          {{ 'virusMonitor.dashboardWidget.viewAdvice' | translate }}
        </button>
      }
    } @else if (store.virusMonitorRegistrationsIsLoading()) {
      <div class="loading-state">
        <app-loading-spinner></app-loading-spinner>
      </div>
    } @else {
      <app-empty-widget [text]="'virusMonitor.nonPremiumText' | translate" />
    }
  </div>
</agr-summary-card>
